import React from 'react';
import { ShowIf, ShowIfCheck, validatable } from 'components/utils';
import { ContainerFileDinhKem } from 'components/upload';
import moment from 'moment';
import { Link } from 'react-router';
import { Input, TextArea, InputNumber, InputList } from 'components/tt-forms/common';
import { DropDownMulipleUse } from 'components/tt-forms';
import { ThanhTra, GiaiQuyetDonThu } from 'api';
import { Toastr } from 'modules/toastr';
import { msg } from 'constants/message';
import { get, isString } from 'lodash';
require('./style.scss');
const loaiQuyTrinh = 'THANH_TRA';

class DoiTuongKienNghi extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dataDetail: {},
      showFile: true,
      action: false,
      idCuocThanhTra: this.props.idCuocThanhTra,
      id: this.props.id,

      linhVucThanhTra: this.props.linhVucThanhTra,
      listDoiTuongViPham: this.props.listDoiTuongViPham,
      chucNangCuocThanhTra: this.props.chucNangCuocThanhTra,
      listLinhVucThanhTra: [],
      linhVucKetQuaThanhTra: '',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: {
        chuyenCoQuanDieuTra: [],
        data: [],
        kienNghiHoanThienCoCheChinhSach: []
      },
      dataTaiLieuVanThuDelete: [],
      dataCoQuanDieuTraThanhTra: [],
      dataHinhThucKienNghi: [],

      listTaiLieuVanThuGiaHan: [],
      danhSachDonViPhoiHop: [],
      donViPhoiHop: '',
      trangThaiDoiTuongViPham: '',
      btnLoading: false,
      btnSaveLoading: false,
      //default

      ten: '',
      // 2. Thu hồi trong quá trình thanh tra
      tienDaThuHoiVeNganSachNhaNuoc: '',
      datDaThuHoiVeNganSachNhaNuoc: '',
      tienDaThuTrongQuaTrinhThanhTra: '',
      datDaThuTrongQuaTrinhThanhTra: '',
      toChucCoSaiPham: '',
      hinhThucKienNghiToChuc: '',
      kienNghiXuLyHanhChinhToChucBangTien: '',
      caNhanCoSaiPham: '',
      kienNghiXuLyHanhChinhCaNhanBangTien: '',
      hinhThucKienNghiCaNhan: '',

      saiPhamKhac: '',

      soVuViecKienNghiChuyenCoQuanDieuTra: 0,
      chuyenCoQuanDieuTra: false,

      soQuyetDinhChuyenCoQuanDieuTra: '',
      nguoiRaQuyetDinhChuyenCoQuanDieuTra: '',
      coQuanDieuTraThanhTra: '',
      coQuanDieuTraKhac: '',

      soVuChuyenCoQuanDieuTra: 0,

      tienKienNghiXuLyKhac: '',
      datKienNghiXuLyKhac: '',
      noiDungKienNghiXuLyKhac: '',

      //end

      //list tài liệu

      listTaiLieuVanThuChuyenCoQuanDieuTra: [],
      listTaiLieuVanThuChuyenCoQuanDieuTraInit: [],
      listTaiLieuVanThuKienNghiXuLyKhac: [],
      dsTaiLieuKienNghiHoanThienCoCheChinhSach: [],

      // Tài chính
      saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe: '',
      saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe: '',
      //end


      // Xây dựng cơ bản
      saiPhamVeTienKienNghiKhacXuLyVeKinhTe: '',
      saiPhamVeDatKienNghiKhacXuLyVeKinhTe: '',
      //end

      // vi phạm về đất đai

      quyetDinhGiaoDat: '',
      cNChoThueKhongDungQDKienNghiXuLyVeDat: '',
      capBanDatTraiThamQuyenKienNghiXuLyVeDat: '',
      datLanChiemKienNghiXuLyVeDat: '',
      capGCNQSDDatSaiKienNghiXuLyVeDat: '',
      giaoCapDatSaiDoiTuongQDKienNghiXuLyVeDat: '',
      sDDatKhongDungMDKienNghiXuLyVeDat: '',
      saiPhamKhacKienNghiXuLyVeDat: '',

      //Lĩnh vực chuyên ngành => không có chuyển cở quan điều tra,

      tongSoTienViPhamKienNghiXuLyVeKinhTe: '',
      tienCaNhanViPhamKienNghiXuLyVeKinhTe: '',
      tienToChucViPhamKienNghiXuLyVeKinhTe: '',

      soTienKienNghiThuHoiKienNghiXuLyVeKinhTe: '',

      tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: '',
      tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: '',
      tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: '',

      tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe: '',
      tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe: '',
      tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe: '',

      //thu hồi trong quá trình thanh tra

      tongSoTienThuHoiTrongQuaTrinhThanhTra: '',
      caNhanTienThuHoiTrongQuaTrinhThanhTra: '',
      toChucTienThuHoiTrongQuaTrinhThanhTra: '',
      showLoaiDoiTuong: false,
      loaiDoiTuongThanhTra: 'TO_CHUC',
      loaiDoiTuongCombobox: [],
    }
  }

  componentDidMount() {
    this.getListLinhVucThanhTra();
    this.getCoQuanDieuTraThanhTra();
    this.getHinhThucKienNghi();
    this.getListLoaiDoiTuong();
    this.props.onRef(this);
    if (this.state.id) {
      this.getChiTietDoiTuongTraThanhTra(this.state.id)
    }
  }

  getChiTietDoiTuongTraThanhTra(id) {
    ThanhTra.actions.getChiTietDoiTuongTraThanhTra.request({ id: id }).then(res => {
      if (res.data) {
        let Data = res.data;
        this.setState({
          dataDetail: Data,
          ten: Data.ten ? Data.ten : '',
          loaiDoiTuongThanhTra: Data.loaiDoiTuongThanhTra ? Data.loaiDoiTuongThanhTra : null,
          tienDaThuHoiVeNganSachNhaNuoc: Data.tienDaThuHoiVeNganSachNhaNuoc ? Data.tienDaThuHoiVeNganSachNhaNuoc : '',
          datDaThuHoiVeNganSachNhaNuoc: Data.datDaThuHoiVeNganSachNhaNuoc ? Data.datDaThuHoiVeNganSachNhaNuoc : '',
          tienDaThuTrongQuaTrinhThanhTra: Data.tienDaThuTrongQuaTrinhThanhTra ? Data.tienDaThuTrongQuaTrinhThanhTra : '',
          datDaThuTrongQuaTrinhThanhTra: Data.datDaThuTrongQuaTrinhThanhTra ? Data.datDaThuTrongQuaTrinhThanhTra : '',
          toChucCoSaiPham: Data.toChucCoSaiPham ? Data.toChucCoSaiPham : '',
          dataToChucCoSaiPham: Data.toChucCoSaiPham ? Data.toChucCoSaiPham : '',
          hinhThucKienNghiToChuc: Data.hinhThucKienNghiToChuc ? Data.hinhThucKienNghiToChuc : '',
          kienNghiXuLyHanhChinhToChucBangTien: Data.kienNghiXuLyHanhChinhToChucBangTien ? Data.kienNghiXuLyHanhChinhToChucBangTien : '',
          kienNghiXuLyHanhChinhCaNhanBangTien: Data.kienNghiXuLyHanhChinhCaNhanBangTien ? Data.kienNghiXuLyHanhChinhCaNhanBangTien : '',
          caNhanCoSaiPham: Data.caNhanCoSaiPham ? Data.caNhanCoSaiPham : '',
          dataCaNhanCoSaiPham: Data.caNhanCoSaiPham ? Data.caNhanCoSaiPham : '',
          hinhThucKienNghiCaNhan: Data.hinhThucKienNghiCaNhan ? Data.hinhThucKienNghiCaNhan : '',

          saiPhamKhac: Data.saiPhamKhac ? Data.saiPhamKhac : '',
          linhVucKetQuaThanhTra: Data.linhVucKetQuaThanhTra ? Data.linhVucKetQuaThanhTra.giaTri : '',

          soVuViecKienNghiChuyenCoQuanDieuTra: Data.soVuViecKienNghiChuyenCoQuanDieuTra ? Data.soVuViecKienNghiChuyenCoQuanDieuTra : 0,
          chuyenCoQuanDieuTra: Data.chuyenCoQuanDieuTra,
          trangThaiDoiTuongViPham: Data.trangThaiDoiTuongViPham ? Data.trangThaiDoiTuongViPham : '',

          soQuyetDinhChuyenCoQuanDieuTra: Data.soQuyetDinhChuyenCoQuanDieuTra ? Data.soQuyetDinhChuyenCoQuanDieuTra : '',
          nguoiRaQuyetDinhChuyenCoQuanDieuTra: Data.nguoiRaQuyetDinhChuyenCoQuanDieuTra ? Data.nguoiRaQuyetDinhChuyenCoQuanDieuTra : '',
          coQuanDieuTraThanhTra: Data.coQuanDieuTraThanhTra ? Data.coQuanDieuTraThanhTra : '',
          coQuanDieuTraKhac: Data.coQuanDieuTraKhac ? Data.coQuanDieuTraKhac : '',

          soVuChuyenCoQuanDieuTra: Data.soVuChuyenCoQuanDieuTra ? Data.soVuChuyenCoQuanDieuTra : 0,

          tienKienNghiXuLyKhac: Data.tienKienNghiXuLyKhac ? Data.tienKienNghiXuLyKhac : '',
          datKienNghiXuLyKhac: Data.datKienNghiXuLyKhac ? Data.datKienNghiXuLyKhac : '',
          noiDungKienNghiXuLyKhac: Data.noiDungKienNghiXuLyKhac ? Data.noiDungKienNghiXuLyKhac : '',

          //end
          boHoanHoaKienNghiXuLyVeDat: Data.boHoanHoaKienNghiXuLyVeDat ? Data.boHoanHoaKienNghiXuLyVeDat : '',
          cNChoThueKhongDungQDKienNghiXuLyVeDat: Data.cNChoThueKhongDungQDKienNghiXuLyVeDat ? Data.cNChoThueKhongDungQDKienNghiXuLyVeDat : '',
          capBanDatTraiThamQuyenKienNghiXuLyVeDat: Data.capBanDatTraiThamQuyenKienNghiXuLyVeDat ? Data.capBanDatTraiThamQuyenKienNghiXuLyVeDat : '',
          datLanChiemKienNghiXuLyVeDat: Data.datLanChiemKienNghiXuLyVeDat ? Data.datLanChiemKienNghiXuLyVeDat : '',
          capGCNQSDDatSaiKienNghiXuLyVeDat: Data.capGCNQSDDatSaiKienNghiXuLyVeDat ? Data.capGCNQSDDatSaiKienNghiXuLyVeDat : '',
          giaoCapDatSaiDoiTuongQDKienNghiXuLyVeDat: Data.giaoCapDatSaiDoiTuongQDKienNghiXuLyVeDat ? Data.giaoCapDatSaiDoiTuongQDKienNghiXuLyVeDat : '',
          sDDatKhongDungMDKienNghiXuLyVeDat: Data.sDDatKhongDungMDKienNghiXuLyVeDat ? Data.sDDatKhongDungMDKienNghiXuLyVeDat : '',
          saiPhamKhacKienNghiXuLyVeDat: Data.saiPhamKhacKienNghiXuLyVeDat ? Data.saiPhamKhacKienNghiXuLyVeDat : '',

          //list tài liệu
          listTaiLieuVanThuChuyenCoQuanDieuTra: Data.listTaiLieuVanThuChuyenCoQuanDieuTra ? Data.listTaiLieuVanThuChuyenCoQuanDieuTra : [],
          listTaiLieuVanThuChuyenCoQuanDieuTraInit: Data.listTaiLieuVanThuChuyenCoQuanDieuTra ? Data.listTaiLieuVanThuChuyenCoQuanDieuTra : [],
          listTaiLieuVanThuKienNghiXuLyKhac: Data.listTaiLieuVanThuKienNghiXuLyKhac ? Data.listTaiLieuVanThuKienNghiXuLyKhac : [],
          dsTaiLieuKienNghiHoanThienCoCheChinhSach: Data.dsTaiLieuKienNghiHoanThienCoCheChinhSach ? Data.dsTaiLieuKienNghiHoanThienCoCheChinhSach : [],

          // Tài chính
          saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe: Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe : '',
          saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe: Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe : '',
          //end


          // Xây dựng cơ bản
          saiPhamVeTienKienNghiKhacXuLyVeKinhTe: Data.saiPhamVeTienKienNghiKhacXuLyVeKinhTe ? Data.saiPhamVeTienKienNghiKhacXuLyVeKinhTe : '',
          saiPhamVeDatKienNghiKhacXuLyVeKinhTe: Data.saiPhamVeDatKienNghiKhacXuLyVeKinhTe ? Data.saiPhamVeDatKienNghiKhacXuLyVeKinhTe : '',
          //end

          // vi phạm về đất đai

          quyetDinhGiaoDat: Data.quyetDinhGiaoDat ? Data.quyetDinhGiaoDat : '',

          //Lĩnh vực chuyên ngành => không có chuyển cở quan điều tra,

          tongSoTienViPhamKienNghiXuLyVeKinhTe: Data.tongSoTienViPhamKienNghiXuLyVeKinhTe ? Data.tongSoTienViPhamKienNghiXuLyVeKinhTe : '',
          tienCaNhanViPhamKienNghiXuLyVeKinhTe: Data.tienCaNhanViPhamKienNghiXuLyVeKinhTe ? Data.tienCaNhanViPhamKienNghiXuLyVeKinhTe : '',
          tienToChucViPhamKienNghiXuLyVeKinhTe: Data.tienToChucViPhamKienNghiXuLyVeKinhTe ? Data.tienToChucViPhamKienNghiXuLyVeKinhTe : '',

          soTienKienNghiThuHoiKienNghiXuLyVeKinhTe: Data.soTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? Data.soTienKienNghiThuHoiKienNghiXuLyVeKinhTe : '',

          tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: Data.tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? Data.tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : '',
          tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: Data.tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? Data.tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : '',
          tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: Data.tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? Data.tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : '',

          tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe: Data.tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe ? Data.tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe : '',
          tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe: Data.tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe ? Data.tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe : '',
          tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe: Data.tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe ? Data.tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe : '',

          //thu hồi trong quá trình thanh tra

          tongSoTienThuHoiTrongQuaTrinhThanhTra: Data.tongSoTienThuHoiTrongQuaTrinhThanhTra ? Data.tongSoTienThuHoiTrongQuaTrinhThanhTra : '',
          caNhanTienThuHoiTrongQuaTrinhThanhTra: Data.caNhanTienThuHoiTrongQuaTrinhThanhTra ? Data.caNhanTienThuHoiTrongQuaTrinhThanhTra : '',
          toChucTienThuHoiTrongQuaTrinhThanhTra: Data.toChucTienThuHoiTrongQuaTrinhThanhTra ? Data.toChucTienThuHoiTrongQuaTrinhThanhTra : '',

          showFile: false
        }, () => {
          this.checkFileRequire()
        })
      }
    })
  }

  checkFileRequire() {
    if (this.state.chuyenCoQuanDieuTra) {
      let data = [...this.state.listTaiLieuVanThuChuyenCoQuanDieuTra];
      let dataFilter = data.filter(state => {
        return state.typeRequired == 'DTTT_CHUYEN_CO_QUAN_DIEU_TRA'
      })
      if (dataFilter.length > 0) {
        // do nothing
      } else {
        let newItem = {
          ten: 'Quyết định chuyển cơ quan điều tra',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'DTTT_CHUYEN_CO_QUAN_DIEU_TRA',
          newFile: true,
          nhomHoSo: null
        }
        this.state.listTaiLieuVanThuChuyenCoQuanDieuTra = [
          ...this.state.listTaiLieuVanThuChuyenCoQuanDieuTra,
          newItem
        ]
      }
    }
    this.setState({
      ...this.state,
      showFile: true
    })
  }

  getParams() {
    let params = {};
    if (this.state.id) {
      params = this.state.dataDetail;
      params.id = params.doiTuongViPhamId;
    }
    params.loaiDoiTuongViPham = 'DOI_TUONG_THEO_DOI';
    params.ten = this.state.ten ? this.state.ten : '';
    params.toChucCoSaiPham = this.state.toChucCoSaiPham ? this.state.toChucCoSaiPham : '';
    params.hinhThucKienNghiToChuc = this.state.hinhThucKienNghiToChuc ? this.state.hinhThucKienNghiToChuc : '';
    params.kienNghiXuLyHanhChinhToChucBangTien = this.state.kienNghiXuLyHanhChinhToChucBangTien ? this.state.kienNghiXuLyHanhChinhToChucBangTien : '';
    params.kienNghiXuLyHanhChinhCaNhanBangTien = this.state.kienNghiXuLyHanhChinhCaNhanBangTien ? this.state.kienNghiXuLyHanhChinhCaNhanBangTien : '';
    params.caNhanCoSaiPham = this.state.caNhanCoSaiPham ? this.state.caNhanCoSaiPham : '';
    params.hinhThucKienNghiCaNhan = this.state.hinhThucKienNghiCaNhan ? this.state.hinhThucKienNghiCaNhan : '';

    params.saiPhamKhac = this.state.saiPhamKhac ? this.state.saiPhamKhac : '';
    params.linhVucKetQuaThanhTra = this.state.linhVucKetQuaThanhTra ? this.state.linhVucKetQuaThanhTra : '';
    params.loaiDoiTuongThanhTra = this.showLoaiDoiTuong() && this.state.loaiDoiTuongThanhTra ? this.state.loaiDoiTuongThanhTra : null;


    if (this.state.chuyenCoQuanDieuTra) {
      params.chuyenCoQuanDieuTra = true;
      params.soQuyetDinhChuyenCoQuanDieuTra = this.state.soQuyetDinhChuyenCoQuanDieuTra ? this.state.soQuyetDinhChuyenCoQuanDieuTra : '';
      params.nguoiRaQuyetDinhChuyenCoQuanDieuTra = this.state.nguoiRaQuyetDinhChuyenCoQuanDieuTra ? this.state.nguoiRaQuyetDinhChuyenCoQuanDieuTra : '';
      params.coQuanDieuTraThanhTra = this.state.coQuanDieuTraThanhTra ? this.state.coQuanDieuTraThanhTra : null;
      params.soVuChuyenCoQuanDieuTra = this.state.soVuChuyenCoQuanDieuTra ? this.state.soVuChuyenCoQuanDieuTra : 0;

      if (this.state.coQuanDieuTraThanhTra == 'KHAC') {
        params.coQuanDieuTraKhac = this.state.coQuanDieuTraKhac ? this.state.coQuanDieuTraKhac : '';
      } else {
        params.coQuanDieuTraKhac = '';
      }
    } else {
      params.chuyenCoQuanDieuTra = false;
      params.soQuyetDinhChuyenCoQuanDieuTra = '';
      params.nguoiRaQuyetDinhChuyenCoQuanDieuTra = '';
      params.coQuanDieuTraThanhTra = null;
      params.coQuanDieuTraKhac = '';
      params.soVuChuyenCoQuanDieuTra = 0;
    }

    params.soVuViecKienNghiChuyenCoQuanDieuTra = this.state.soVuViecKienNghiChuyenCoQuanDieuTra ? this.state.soVuViecKienNghiChuyenCoQuanDieuTra : 0;
    params.tienDaThuHoiVeNganSachNhaNuoc = this.state.tienDaThuHoiVeNganSachNhaNuoc ? this.state.tienDaThuHoiVeNganSachNhaNuoc : 0;
    params.datDaThuHoiVeNganSachNhaNuoc = this.state.datDaThuHoiVeNganSachNhaNuoc ? this.state.datDaThuHoiVeNganSachNhaNuoc : 0;
    params.tienDaThuTrongQuaTrinhThanhTra = this.state.tienDaThuTrongQuaTrinhThanhTra ? this.state.tienDaThuTrongQuaTrinhThanhTra : 0;
    params.datDaThuTrongQuaTrinhThanhTra = this.state.datDaThuTrongQuaTrinhThanhTra ? this.state.datDaThuTrongQuaTrinhThanhTra : 0;
    params.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe = this.state.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? this.state.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe : 0;
    params.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe = this.state.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe ? this.state.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe : 0;
    params.datKienNghiXuLyKhac = this.state.datKienNghiXuLyKhac ? this.state.datKienNghiXuLyKhac : 0;
    params.noiDungKienNghiXuLyKhac = this.state.noiDungKienNghiXuLyKhac ? this.state.noiDungKienNghiXuLyKhac : '';

    params.tienKienNghiXuLyKhac = this.state.tienKienNghiXuLyKhac ? this.state.tienKienNghiXuLyKhac : 0;

    params.saiPhamVeTienKienNghiKhacXuLyVeKinhTe = this.state.saiPhamVeTienKienNghiKhacXuLyVeKinhTe ? this.state.saiPhamVeTienKienNghiKhacXuLyVeKinhTe : 0;
    params.saiPhamVeDatKienNghiKhacXuLyVeKinhTe = this.state.saiPhamVeDatKienNghiKhacXuLyVeKinhTe ? this.state.saiPhamVeDatKienNghiKhacXuLyVeKinhTe : 0;
    params.quyetDinhGiaoDatThuHoiTrongQuaTrinhThanhTra = 0;
    params.soQuyetDinhKienNghiXuLyHanhChinhCaNhan = '';
    params.soQuyetDinhKienNghiXuLyHanhChinhToChuc = '';

    //end

    params.tongSoTienViPhamKienNghiXuLyVeKinhTe = this.state.tongSoTienViPhamKienNghiXuLyVeKinhTe ? this.state.tongSoTienViPhamKienNghiXuLyVeKinhTe : 0;
    params.tienCaNhanViPhamKienNghiXuLyVeKinhTe = this.state.tienCaNhanViPhamKienNghiXuLyVeKinhTe ? this.state.tienCaNhanViPhamKienNghiXuLyVeKinhTe : 0;
    params.tienToChucViPhamKienNghiXuLyVeKinhTe = this.state.tienToChucViPhamKienNghiXuLyVeKinhTe ? this.state.tienToChucViPhamKienNghiXuLyVeKinhTe : 0;

    params.soTienKienNghiThuHoiKienNghiXuLyVeKinhTe = this.state.soTienKienNghiThuHoiKienNghiXuLyVeKinhTe ? this.state.soTienKienNghiThuHoiKienNghiXuLyVeKinhTe : 0;

    params.tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe = this.state.tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? this.state.tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : 0;
    params.tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe = this.state.tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? this.state.tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : 0;
    params.tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe = this.state.tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe ? this.state.tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe : 0;

    params.tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe = this.state.tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe ? this.state.tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe : 0;
    params.tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe = this.state.tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe ? this.state.tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe : 0;
    params.tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe = this.state.tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe ? this.state.tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe : 0;

    params.tongSoTienThuHoiTrongQuaTrinhThanhTra = this.state.tongSoTienThuHoiTrongQuaTrinhThanhTra ? this.state.tongSoTienThuHoiTrongQuaTrinhThanhTra : 0;
    params.caNhanTienThuHoiTrongQuaTrinhThanhTra = this.state.caNhanTienThuHoiTrongQuaTrinhThanhTra ? this.state.caNhanTienThuHoiTrongQuaTrinhThanhTra : 0;
    params.toChucTienThuHoiTrongQuaTrinhThanhTra = this.state.toChucTienThuHoiTrongQuaTrinhThanhTra ? this.state.toChucTienThuHoiTrongQuaTrinhThanhTra : 0;
    params.loaiDoiTuongThanhTraInfo = undefined;

    params.cuocThanhTra = {
      id: Number(this.state.idCuocThanhTra)
    }

    delete params['_links'];
    delete params['nguoiSuaInfo'];
    delete params['nguoiTaoInfo'];
    delete params['ngaySua'];
    delete params['ngayTao'];
    delete params['cuocThanhTraId'];
    delete params['doiTuongViPhamId'];
    delete params['listTaiLieuVanThuChuyenCoQuanDieuTra'];
    delete params['listTaiLieuVanThuKienNghiXuLyKhac'];
    delete params['dsTaiLieuKienNghiHoanThienCoCheChinhSach'];
    delete params['trangThaiDoiTuongViPhamInfo'];
    delete params['coQuanDieuTraThanhTraInfo'];

    return params;
  }

  handleSave() {
    if (!this.state.ten || !this.state.linhVucKetQuaThanhTra) {
      Toastr('Chọn đối tượng vi phạm và lĩnh vực', 'warning');
    } else {
      this.setState({ btnSaveLoading: true });
      let params = this.getParams();
      if (params.trangThaiDoiTuongViPham != 'HOAN_THANH') {
        params.trangThaiDoiTuongViPham = 'DANG_SOAN';
      }
      if (this.state.id) {
        this.pushTaiLieu(this.state.id);
        this.updateDoiTuongViPham(params);
      } else {
        this.postDoiTuongViPham(params);
      }
    }
  }

  handleKetThuc() {
    if (!this.state.ten || !this.state.linhVucKetQuaThanhTra) {
      Toastr('Chọn đối tượng vi phạm và lĩnh vực', 'warning');
    } else {
      if (this.validateSubmitForm()) {
        this.setState({ btnLoading: true });
        let params = this.getParams();
        params.trangThaiDoiTuongViPham = 'HOAN_THANH';
        if (this.state.id) {
          this.pushTaiLieu(this.state.id);
          this.updateDoiTuongViPham(params);
        } else {
          this.postDoiTuongViPham(params);
        }
      }
    }
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  postDoiTuongViPham(data) {
    let params = {
      doiTuongViPhams: [
        data
      ]
    }
    ThanhTra.actions.postDoiTuongViPham.request('', params).then(res => {
      //do something
      this.pushTaiLieu(res.data.doiTuongViPhams[0].doiTuongViPhamId)
      Toastr(msg.addDoiTuongTTSuccess, 'success');
      this.setState({ btnLoading: false, btnSaveLoading: false });
      this.props.closeDialog(true);
      this.props.getListDaTa();
    }).catch(e => {
      this.setState({ btnLoading: false, btnSaveLoading: false });
    })
  }

  updateDoiTuongViPham(data) {
    let params = {
      doiTuongViPhams: [
        data
      ]
    }
    ThanhTra.actions.updateDoiTuongViPham.request('', params).then(res => {
      //do something
      Toastr(msg.saveDoiTuongTTSuccess, 'success');
      this.setState({ btnLoading: false, btnSaveLoading: false });
      this.props.closeDialog(true);
      this.props.getListDaTa();
    }).catch(e => {
      this.setState({ btnLoading: false, btnSaveLoading: false });
    });
  }

  getCoQuanDieuTraThanhTra() {
    ThanhTra.actions.getCoQuanDieuTraThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataCoQuanDieuTraThanhTra: res.data
        })
      }
    })
  }

  getListLinhVucThanhTra() {
    ThanhTra.actions.getDsLinhVucThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          listLinhVucThanhTra: res.data
        })
      }
    })
  }

  getListLoaiDoiTuong() {
    ThanhTra.actions.getDsLoaiDoiTuong.request().then(res => {
      if (res.data) {
        this.setState({
          loaiDoiTuongCombobox: res.data.reverse()
        })
      }
    })
  }

  getHinhThucKienNghi() {
    ThanhTra.actions.getHinhThucKienNghi.request().then(res => {
      if (res.data) {
        this.setState({
          dataHinhThucKienNghi: res.data
        })
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      linhVucThanhTra: nextProps.linhVucThanhTra,
      listDoiTuongViPham: nextProps.listDoiTuongViPham,
      idCuocThanhTra: nextProps.idCuocThanhTra,
      chucNangCuocThanhTra: nextProps.chucNangCuocThanhTra,
      id: nextProps.id
    })
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
    if (name == 'coQuanDieuTraThanhTra') {

    }
    this.props.handleChangeData();
  }

  onFileChange(data, type) {
    if (type == 'CHUYEN_CO_QUAN_DIEU_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.chuyenCoQuanDieuTra = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type === "KIEN_NGHI_HOAN_THIEN_CO_CHE_CHINH_SACH") {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.kienNghiHoanThienCoCheChinhSach = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    }
    else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    }
    this.props.handleChangeData();
  }

  onFileRemove(id, data, type) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });
    if (type == 'CHUYEN_CO_QUAN_DIEU_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.chuyenCoQuanDieuTra = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type === 'KIEN_NGHI_HOAN_THIEN_CO_CHE_CHINH_SACH') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.kienNghiHoanThienCoCheChinhSach = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    }


    this.props.handleChangeData();
  }

  pushTaiLieu(id) {

    let dataFileDinhKem = this.getListDataFileDinhKem();

    if (dataFileDinhKem.length > 0) {
      dataFileDinhKem.map((item, i) => {
        if (item.taiLieuVanThuId) {
          this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
            doiTuongViPham: {
              id: Number(id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiQuyTrinh: item.loaiQuyTrinh,
            buocGiaiQuyet: item.buocGiaiQuyet,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : '',
            nhomHoSo: item.nhomHoSo && isString(item.nhomHoSo) ? {
              id: Number(item.nhomHoSo)
            } : get(item, 'nhomHoSoInfo.nhomHoSoId') ? { id: get(item, 'nhomHoSoInfo.nhomHoSoId') } : null
          };
        } else {
          this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
            doiTuongViPham: {
              id: Number(id)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiQuyTrinh: loaiQuyTrinh,
            buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : '',
            nhomHoSo: item.nhomHoSo && isString(item.nhomHoSo) ? {
              id: Number(item.nhomHoSo)
            } : get(item, 'nhomHoSoInfo.nhomHoSoId') ? { id: get(item, 'nhomHoSoInfo.nhomHoSoId') } : null
          };
        }
      });
    }

    if (this.state.chuyenCoQuanDieuTra != true && this.state.listTaiLieuVanThuChuyenCoQuanDieuTraInit.length > 0) {
      let dataFile = [...this.state.listTaiLieuVanThuChuyenCoQuanDieuTraInit]
      dataFile.map(item => {
        this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
          id: item.taiLieuVanThuId
        };
      });
    }

    if (this.state.dataTaiLieuVanThuDelete.length > 0) {
      this.state.dataTaiLieuVanThuDelete.map(item => {
        this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
          id: item
        };
      });
    }

    if (this.state.taiLieuVanThu.length > 0) {
      let params = {
        taiLieuVanThus: this.state.taiLieuVanThu
      }
      this.postTaiLieuVanThu(params);
    }

    if (this.state.taiLieuVanThuUpdate.length > 0) {
      let params = {
        taiLieuVanThus: this.state.taiLieuVanThuUpdate
      }
      this.updateTaiLieuVanThu(params);
    }

    if (this.state.taiLieuVanThuDelete.length > 0) {

      let params = {
        taiLieuVanThus: this.state.taiLieuVanThuDelete
      }
      this.deleteTaiLieuVanThu(params);
    }
  }

  getListDataFileDinhKem() {
    let dataFileDinhKem = []
    let Data = this.state.dataFileDinhKem;

    if (Data.chuyenCoQuanDieuTra.length > 0) {
      Data.chuyenCoQuanDieuTra.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.kienNghiHoanThienCoCheChinhSach.length > 0) {
      Data.kienNghiHoanThienCoCheChinhSach.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.data.length > 0) {
      Data.data.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    return dataFileDinhKem;
  }

  updateTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  deleteTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  handleCheck(name, e) {
    this.setState({
      [name]: e,
      showFile: false
    }, () => {
      this.checkFileRequire();
    })
    if (!e) {

    }
    this.props.handleChangeData();
  }

  closeDialog() {
    this.props.closeDialog();
  }

  resetData() {
    this.setState({
      idCuocThanhTra: '',
      id: '',
      linhVucThanhTra: '',
      listDoiTuongViPham: [],
      chucNangCuocThanhTra: '',
      ten: '',
      loaiDoiTuongThanhTra: '',
      tienDaThuHoiVeNganSachNhaNuoc: '',
      datDaThuHoiVeNganSachNhaNuoc: '',
      tienDaThuTrongQuaTrinhThanhTra: '',
      datDaThuTrongQuaTrinhThanhTra: '',
      toChucCoSaiPham: '',
      hinhThucKienNghiToChuc: '',
      kienNghiXuLyHanhChinhToChucBangTien: '',
      kienNghiXuLyHanhChinhCaNhanBangTien: '',
      caNhanCoSaiPham: '',
      hinhThucKienNghiCaNhan: '',

      saiPhamKhac: '',

      soVuViecKienNghiChuyenCoQuanDieuTra: 0,
      chuyenCoQuanDieuTra: false,

      soQuyetDinhChuyenCoQuanDieuTra: '',
      nguoiRaQuyetDinhChuyenCoQuanDieuTra: '',
      coQuanDieuTraThanhTra: '',
      coQuanDieuTraKhac: '',

      soVuChuyenCoQuanDieuTra: '',

      tienKienNghiXuLyKhac: '',
      datKienNghiXuLyKhac: '',
      noiDungKienNghiXuLyKhac: '',

      //end

      // Tài chính
      saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe: '',
      saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe: '',
      //end


      // Xây dựng cơ bản
      saiPhamVeTienKienNghiKhacXuLyVeKinhTe: '',
      saiPhamVeDatKienNghiKhacXuLyVeKinhTe: '',
      //end

      // vi phạm về đất đai

      quyetDinhGiaoDat: '',

      //Lĩnh vực chuyên ngành => không có chuyển cở quan điều tra,

      tongSoTienViPhamKienNghiXuLyVeKinhTe: '',
      tienCaNhanViPhamKienNghiXuLyVeKinhTe: '',
      tienToChucViPhamKienNghiXuLyVeKinhTe: '',

      soTienKienNghiThuHoiKienNghiXuLyVeKinhTe: '',

      tongSoTienXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: '',
      tienTichThuXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: '',
      tienTieuHuyXuLyTaiSanViPhamKienNghiXuLyVeKinhTe: '',

      tongSoTienXuPhatViPhamKienNghiXuLyVeKinhTe: '',
      tienCaNhanXuPhatViPhamKienNghiXuLyVeKinhTe: '',
      tienToChucXuPhatViPhamKienNghiXuLyVeKinhTe: '',

      //thu hồi trong quá trình thanh tra

      tongSoTienThuHoiTrongQuaTrinhThanhTra: '',
      caNhanTienThuHoiTrongQuaTrinhThanhTra: '',
      toChucTienThuHoiTrongQuaTrinhThanhTra: '',
    })
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if (pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });

    return pass;
  }

  showLoaiDoiTuong() {
    let result = false;
    if (this.props.doiTuongThanhTraLienQuan.split('; ').includes(this.state.ten)) {
      result = true;
    }
    return result;
  }

  render() {
    return (
      <section className="wrap-dtkn">
        <div className='content-dtkn'>
          <div className='wrap-items-content'>
            <div className='col-100 no-gutter'>
              <h2 className='title-14 col-100 mb5'>1. Đối tượng vi phạm</h2>
              <DropDownMulipleUse label="Tên đối tượng" className='col-50' data={this.state.listDoiTuongViPham} keyName='giaTri' valueName='ten' selectedValue={this.state.ten} onChange={this.onChange.bind(this, 'ten')} name='ten' />
              {
                this.showLoaiDoiTuong() && (
                  <DropDownMulipleUse placeholder={null} label="Loại đối tượng" className='col-25' data={this.state.loaiDoiTuongCombobox} keyName='giaTri' valueName='ten' selectedValue={this.state.loaiDoiTuongThanhTra} onChange={this.onChange.bind(this, 'loaiDoiTuongThanhTra')} name='loaiDoiTuongThanhTra' />
                )
              }
              <DropDownMulipleUse label="Loại lĩnh vực vi phạm" className='col-25' data={this.state.listLinhVucThanhTra} keyName='giaTri' valueName='ten' selectedValue={this.state.linhVucKetQuaThanhTra} onChange={this.onChange.bind(this, 'linhVucKetQuaThanhTra')} name='linhVucKetQuaThanhTra' />
            </div>
            <div className='col-100 pb15'><div className='line-border'></div></div>

            <div className='col-100 no-gutter'>
              <h2 className='title-14 col-100 mb10'>2. Kiến nghị thu hồi</h2>
              <div className='col-50 pl0 pr0'>
                <p className='title-group-input'>THU HỒI VỀ NSNN</p>
                <Input type="sdt" align="right" className='col-50' placeholder='Nhập...' label='Về tiền (đ)' value={this.state.tienDaThuHoiVeNganSachNhaNuoc} onChange={this.onChange.bind(this, 'tienDaThuHoiVeNganSachNhaNuoc')} name='tienDaThuHoiVeNganSachNhaNuoc' />
                <Input type="sdt" align="right" className='col-50' placeholder='Nhập...' label='Về đất (m2)' value={this.state.datDaThuHoiVeNganSachNhaNuoc} onChange={this.onChange.bind(this, 'datDaThuHoiVeNganSachNhaNuoc')} name='datDaThuHoiVeNganSachNhaNuoc' />
              </div>
              <div className='col-50 pl0 pr0'>
                <p className='title-group-input'>THU HỒI VỀ TỔ CHỨC, ĐƠN VỊ</p>
                <Input type="sdt" align="right" className='col-50' placeholder='Nhập...' label='Về tiền (đ)' value={this.state.tienDaThuTrongQuaTrinhThanhTra} onChange={this.onChange.bind(this, 'tienDaThuTrongQuaTrinhThanhTra')} name='tienDaThuTrongQuaTrinhThanhTra' />
                <Input type="sdt" align="right" className='col-50' placeholder='Nhập...' label='Về đất (m2)' value={this.state.datDaThuTrongQuaTrinhThanhTra} onChange={this.onChange.bind(this, 'datDaThuTrongQuaTrinhThanhTra')} name='datDaThuTrongQuaTrinhThanhTra' />
              </div>
            </div>
            <div className='col-100 pb15'><div className='line-border'></div></div>

            <div className='col-100 no-gutter'>
              <h2 className='title-14 col-100 mb15'>3. Kiến nghị xử lý về kinh tế</h2>
              <div className='col-50 no-gutter'>
                <Input type="sdt" align="right" className='col-50' label='Về tiền (đ)' value={this.state.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe} onChange={this.onChange.bind(this, 'saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe')} name='saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe' />
                <Input type="sdt" align="right" className='col-50' label='Về đất (m2)' value={this.state.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe} onChange={this.onChange.bind(this, 'saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe')} name='saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe' />
              </div>
            </div>
            <div className='col-100 pb15'><div className='line-border'></div></div>

            <div className='col-100 no-gutter'>
              <h2 className='title-14 col-100 mb10'>4. Kiến nghị xử lý về hành chính</h2>
              <InputList label='Tổ chức có sai phạm' data={this.state.dataToChucCoSaiPham} onChange={this.onChange.bind(this, 'toChucCoSaiPham')} name='toChucCoSaiPham' countUnit='tổ chức' hasCount={true} />
              <Input type="sdt" className='col-25' placeholder='Nhập...' label='Bằng tiền (đ)' value={this.state.kienNghiXuLyHanhChinhToChucBangTien} onChange={this.onChange.bind(this, 'kienNghiXuLyHanhChinhToChucBangTien')} name='kienNghiXuLyHanhChinhToChucBangTien' />
              <Input className='col-25' label='Bằng hình thức khác' placeholder='Nhập...' value={this.state.hinhThucKienNghiToChuc} onChange={this.onChange.bind(this, 'hinhThucKienNghiToChuc')} name='hinhThucKienNghiToChuc' maxLength={255} />
              <InputList label='Cá nhân có sai phạm' data={this.state.dataCaNhanCoSaiPham} onChange={this.onChange.bind(this, 'caNhanCoSaiPham')} name='caNhanCoSaiPham' countUnit='cá nhân' hasCount={true} />
              <Input type="sdt" className='col-25' placeholder='Nhập...' label='Bằng tiền (đ)' value={this.state.kienNghiXuLyHanhChinhCaNhanBangTien} onChange={this.onChange.bind(this, 'kienNghiXuLyHanhChinhCaNhanBangTien')} name='kienNghiXuLyHanhChinhCaNhanBangTien' />
              <Input className='col-25' label='Bằng hình thức khác' placeholder='Nhập...' value={this.state.hinhThucKienNghiCaNhan} onChange={this.onChange.bind(this, 'hinhThucKienNghiCaNhan')} name='hinhThucKienNghiCaNhan' maxLength={255} />
            </div>
            <div className='col-100 pb15'><div className='line-border'></div></div>

            <div className='col-100 no-gutter'>
              <h2 className='title-14 col-100 mb10'>5. Kiến nghị chuyển cơ quan điều tra</h2>
              <InputNumber className='col-25' label='Số vụ việc' value={this.state.soVuViecKienNghiChuyenCoQuanDieuTra} onChange={this.onChange.bind(this, 'soVuViecKienNghiChuyenCoQuanDieuTra')} name='soVuViecKienNghiChuyenCoQuanDieuTra' />
              <ShowIfCheck titleClass='title-attach lable-title-custom' className='col-100' onChange={this.handleCheck.bind(this, 'chuyenCoQuanDieuTra')} name='chuyenCoQuanDieuTra' checked={this.state.chuyenCoQuanDieuTra} label='Chuyển cơ quan điều tra'>
                <div className='wrap-showif-check'>
                  <div className='col-100 no-gutter'>
                    <Input className='col-25' require bindValidator={this} channel='formTaoDon' label='Số quyết định' placeholder='Nhập...' value={this.state.soQuyetDinhChuyenCoQuanDieuTra} onChange={this.onChange.bind(this, 'soQuyetDinhChuyenCoQuanDieuTra')} name='soQuyetDinhChuyenCoQuanDieuTra' maxLength={255} />
                    <Input className='col-25' require bindValidator={this} channel='formTaoDon' label='Người ra quyết định' placeholder='Nhập...' value={this.state.nguoiRaQuyetDinhChuyenCoQuanDieuTra} onChange={this.onChange.bind(this, 'nguoiRaQuyetDinhChuyenCoQuanDieuTra')} name='nguoiRaQuyetDinhChuyenCoQuanDieuTra' maxLength={255} />
                  </div>
                  <div className='col-100 no-gutter'>
                    <DropDownMulipleUse className='col-50' require bindValidator={this} channel='formTaoDon' label='Tên cơ quan' placeholder='Nhập...' selectedValue={this.state.coQuanDieuTraThanhTra} onChange={this.onChange.bind(this, 'coQuanDieuTraThanhTra')} name='coQuanDieuTraThanhTra' data={this.state.dataCoQuanDieuTraThanhTra} keyName='giaTri' valueName='ten' />
                    <ShowIf condition={this.state.coQuanDieuTraThanhTra == 'KHAC'}>
                      <Input className='col-25' require bindValidator={this} channel='formTaoDon' label='Cơ quan điều tra khác' placeholder='Nhập...' value={this.state.coQuanDieuTraKhac} onChange={this.onChange.bind(this, 'coQuanDieuTraKhac')} name='coQuanDieuTraKhac' />
                    </ShowIf>
                    <InputNumber className='col-25' require bindValidator={this} channel='formTaoDon' label='Số vụ' placeholder='Nhập...' value={this.state.soVuChuyenCoQuanDieuTra} onChange={this.onChange.bind(this, 'soVuChuyenCoQuanDieuTra')} name='soVuChuyenCoQuanDieuTra' />
                  </div>
                  <ShowIf condition={this.state.showFile}>
                    <div className='col-100'>
                      <ContainerFileDinhKem name='chuyenCoQuanDieuTra' label="Danh sách văn bản xử lý" phanLoaiQuyTrinh='CHUYEN_CO_QUAN_DIEU_TRA' bindValidator={this} data={this.state.listTaiLieuVanThuChuyenCoQuanDieuTra} disableTopLine={true} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} />
                    </div>
                  </ShowIf>
                </div>
              </ShowIfCheck>
            </div>
            <div className='col-100 pb15'><div className='line-border'></div></div>

            <div className='col-100 no-gutter'>
              <h2 className='title-14 col-100 mb10'>6. Kiến nghị hoàn thiện cơ chế chính sách</h2>
              <div className='col-100'>
                <ContainerFileDinhKem hidenTopTitle name='dsTaiLieuKienNghiHoanThienCoCheChinhSach' label="Danh sách văn bản xử lý" phanLoaiQuyTrinh='KIEN_NGHI_HOAN_THIEN_CO_CHE_CHINH_SACH' bindValidator={this} data={this.state.dsTaiLieuKienNghiHoanThienCoCheChinhSach} disableTopLine={true} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} />
              </div>
            </div>

            <div className='col-100 no-gutter'>
              <h2 className='title-14 col-100 mb10'>7. Kiến nghị xử lý khác</h2>
              <Input type="sdt" align="right" className='col-25' label='Kiến nghị tiền (đ)' value={this.state.tienKienNghiXuLyKhac} onChange={this.onChange.bind(this, 'tienKienNghiXuLyKhac')} name='tienKienNghiXuLyKhac' />
              <ShowIf condition={this.state.chucNangCuocThanhTra != 'CHUYEN_NGANH'}>
                <Input type="sdt" align="right" className='col-25' label='Kiến nghị đất (m2)' value={this.state.datKienNghiXuLyKhac} onChange={this.onChange.bind(this, 'datKienNghiXuLyKhac')} name='datKienNghiXuLyKhac' />
                <TextArea className='col-100' label='Nội dung kiến nghị khác' placeholder='Nhập...' value={this.state.noiDungKienNghiXuLyKhac} onChange={this.onChange.bind(this, 'noiDungKienNghiXuLyKhac')} name='noiDungKienNghiXuLyKhac' maxLength={1000} />
              </ShowIf>
              <ShowIf condition={this.state.showFile}>
                <div className='col-100'>
                  <ContainerFileDinhKem name='kienNghiXuLyKhac' label="Danh sách văn bản xử lý" phanLoaiQuyTrinh='KIEN_NGHI_XU_LY_KHAC' bindValidator={this} data={this.state.listTaiLieuVanThuKienNghiXuLyKhac} disableTopLine={true} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} />
                </div>
              </ShowIf>
            </div>
            <div className="col-100 no-gutter pt15 pb5">
              <div className="box-bottom">
                <Link className="btn-action btn-close" onClick={this.closeDialog.bind(this)}><span>Đóng</span></Link>
                <ShowIf condition={this.state.trangThaiDoiTuongViPham != 'HOAN_THANH'}>
                  <Link className={'btn-action btn-save action-todo ' + (this.state.btnSaveLoading ? "btn-loading-inline" : (this.state.btnLoading && 'btn-disable'))} onClick={this.handleSave.bind(this)}><span>Lưu</span></Link>
                </ShowIf>
                <ShowIf condition={this.state.trangThaiDoiTuongViPham != 'HOAN_THANH'}>
                  <Link className={'btn-action btn-complete btn-right-position action-todo ' + (this.state.btnSaveLoading ? "btn-disable" : (this.state.btnLoading && 'btn-loading-inline'))} onClick={this.handleKetThuc.bind(this)}><span>Hoàn Thành</span></Link>
                </ShowIf>
                <ShowIf condition={this.state.trangThaiDoiTuongViPham == 'HOAN_THANH'}>
                  <Link className={'btn-action btn-complete action-todo ' + (this.state.btnSaveLoading ? "btn-disable" : (this.state.btnLoading && 'btn-loading-inline'))} onClick={this.handleSave.bind(this)}><span>Lưu</span></Link>
                </ShowIf>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

DoiTuongKienNghi.defaultProps = {
  validators: {
    formTaoDon: []
  },
  linhVucThanhTra: [],
  listDoiTuongViPham: []
}

export default validatable(DoiTuongKienNghi);


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/sub-view/DoiTuongKienNghi.jsx